import { render, staticRenderFns } from "./BaseDialogContents.vue?vue&type=template&id=54798988&"
import script from "./BaseDialogContents.vue?vue&type=script&lang=js&"
export * from "./BaseDialogContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports